import withClassName from '../withClassName';

export default withClassName('list__item')('li');
